import styled from 'styled-components';

export default styled.div`
  padding: 14px 8px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
`;
